import { debounceTime, switchMap, take, takeUntil } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { Component, OnInit } from '@angular/core';
import { UIChart } from 'primeng/primeng';
import { Subject } from 'rxjs';
import _ from 'lodash'

import { FilterQueryComponent } from '../shared/component/filter-query/filter-query.component';
import { DashboardService } from '../shared/service/dashboard.service';
import { ConclusionTypes } from '../shared/enum/conclusion-type';
import { UserService } from '../shared/service/user.service';

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent extends FilterQueryComponent implements OnInit {
    show = ['user'];
    
    getOne = new Subject(); endOne = new Subject(); getTwo = new Subject(); endTwo = new Subject(); 
    getThree = new Subject(); endThree = new Subject(); getFourFiveSix = new Subject(); endFour = new Subject();

    monthList = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul","Aug", "Sep", "Oct", "Nov", "Dec"];

    optionsOne: any; optionsTwo: any; optionsFour: any; optionsThree: any; optionsFive: any; optionsSix: any;
    dataOne: any; dataTwo: any; dataFour: any; dataThree: any; dataFive: any; dataSix: any;

    totalOne = 0; totalTwo = 0; totalFour = 0; totalThree = 0; totalFive = 0; totalSix = 0;

    constructor(
		private translateService: TranslateService,
        private dashboardServ: DashboardService, 
        protected userService: UserService 
    ) {
        super(userService);

        this.loadDefaultValues();

        this.getOne.pipe(takeUntil(this.endOne), debounceTime(this.delay),
        switchMap(_ => this.dashboardServ.getScheduleList(this.queryData)))
        .subscribe({ next: (res) => this.setDataOne(res), error: (err) => console.error(err) });

        this.getTwo.pipe(takeUntil(this.endTwo), debounceTime(this.delay),
        switchMap(_ => this.dashboardServ.getActionPlanList(this.queryData)))
        .subscribe({ next: (res) => this.setDataTwo(res), error: (err) => console.error(err) });

        this.getThree.pipe(takeUntil(this.endThree), debounceTime(this.delay),
        switchMap(_ => this.dashboardServ.getUnconformitiesAnswers(this.queryData)))
        .subscribe({ next: (res) => this.setDataThree(res), error: (err) => console.error(err) });

        this.getFourFiveSix.pipe(takeUntil(this.endFour), debounceTime(this.delay),
        switchMap(_ => this.dashboardServ.getChecklistAnswers(this.queryData)))
        .subscribe({ next: (res) => this.setDataFourFiveSix(res), error: (err) => console.error(err) });
    }

    ngOnInit() {
        // this.updateData();
    }

    update(query){
        this.queryData = query;
        this.updateData();
    }

    updateData() {
        this.loading = true;

        this.getOne.next();
        this.getTwo.next();
        this.getThree.next();

        this.getFourFiveSix.next();

        this.refreshCharts();
    }

    setCharts = (charts: UIChart[]) => !this.charts ? this.charts = charts : null;
    
    refreshCharts() {
        if (this.charts) this.charts.forEach((chart) => chart ? chart.refresh() : null);
    };

    setDataOne(response: any) {        
        let { answers, late, pending, schedules } = response;

        this.dataOne.datasets[0].data = [answers, late, pending];
        this.totalOne = schedules;
    }

    setDataTwo(response: any) {
        let { total, values } = response;
        let data = Object.keys(values).map((key) => values[key]);

        this.dataTwo.datasets[0].data = data;
        this.totalTwo = total;
    }

    setDataThree(response: any) {
        let { total, values, unconformities } = response;
        let maxValues = this.getUnconformitiesMaxValues(values);

        // to order by quantity
        maxValues = _.orderBy(maxValues.filter(v => v && v.usageCount), 'usageCount', 'desc');

        this.totalThree = total;
        this.unconformities = unconformities;

        this.dataThree.datasets[0].data = maxValues.map(value => value.usageCount);
        
        this.dataThree.labels = maxValues.map((value => {
            let unco = this.unconformities.find((item) => item.id == value.unconformity_id);
            let label = unco && unco.description && unco.description + (
                unco.deleted_at ? ` (${this.translate('status_deleted')})` : ''
            );

            return label || '';
        }));

        this.dataThree.datasets[0].data.push(0); // to view lower value

        this.loading = false;
    }

    setDataFourFiveSix(response: any) {
        let filterByAprovation = response.values[ConclusionTypes['Por Aprovação']];
        let filterByFilled = response.values[ConclusionTypes['Por Preenchimento']];
        let filterByFinalization = response.values[ConclusionTypes['Por Sinalização']];

        let { approved, reproved } = filterByAprovation;
        
        this.dataFour.datasets[0].data = [approved, reproved];
        this.checklistCount = response.total;

        if (filterByAprovation)
        this.totalFour = approved + reproved;

        this.totalFive = filterByFilled ? filterByFilled.length : 0;
        this.totalSix = filterByFinalization ? filterByFinalization.length : 0;

        this.dataFour.datasets[0].data.push(0); // to view lower value
    }

    getUnconformitiesMaxValues(values: { unconformity_id: number, usageCount: number }[]) {
        let maxValues: { unconformity_id: number, usageCount: number }[] = new Array(values.length + 1);

        for (let i = 0; i < maxValues.length; i++) {
            values.forEach((item) => {
                if (maxValues[i] == null || item.usageCount > maxValues[i].usageCount) {
                    maxValues[i] = item; values.splice(values.indexOf(item), 1);
                }
            });
        }
        
        return maxValues;
    }

    loadDefaultValues() {

        this.translateService
        .get('translate_version')
        .pipe(take(1)).subscribe(_ => {
            this.optionsOne = {
                title: {
                    display: true,
                    text: this.translate('scheduling'),
                    fontSize: 18
                },
                legend: {
                    position: 'bottom'
                }
            };
        
            this.optionsTwo = {
                title: {
                    display: true,
                    text: this.translate('action_plan'),
                    fontSize: 18
                },
                legend: {
                    position: 'bottom'
                }
            };
        
            this.optionsThree = {
                title: {
                    display: true,
                    text: this.translate('unconformities'),
                    fontSize: 18
                },
                legend: {
                    position: 'bottom'
                }
            };
        
            this.optionsFour = {
                title: {
                    display: true,
                    text: this.translate('approved') + ' - ' + this.translate('reproved'),
                    fontSize: 18
                },
                legend: {
                    position: 'bottom'
                }
            };
            
            this.dataOne = {
                labels: [this.translate('answers'), this.translate('delayed'), this.translate('pending')],
                datasets: [
                    {
                        backgroundColor: ["#07994E","#B86D6E", "dodgerblue"].reverse(),
                        // backgroundColor: ["#07994E","#B86D6E"], // light green, crimson
                        label: 'Results',
                        data: [45, 8, 0]
                    }
                ]
            }
        
            this.dataTwo = {
                labels: [this.translate('status_completed'), this.translate('delayed'), this.translate('pending')],
                datasets: [
                    {
                        backgroundColor: ["#07994E","#B86D6E", "dodgerblue"].reverse(), // deepskyblue
                        label: 'Results',
                        data: [110, 15, 45].reverse()
                    }
                ]
            }
        
            this.dataFour = {
                labels: [this.translate('approved'), this.translate('reproved')],
                datasets: [
                    {
                        backgroundColor: ["#1670C7","#B86D6E"],
                        label: this.translate('results'),
                        data: [2000, 200, 0]
                    }
                ]
            }
        
            this.dataThree = {
                labels: ['Motivo 1', 'Motivo 2', 'Motivo 3', 'Motivo 4', 'Motivo 5'],
                datasets: [
                    {
                        labels: ['Motivo 1', 'Motivo 2', 'Motivo 3', 'Motivo 4', 'Motivo 5'],
                        data: [50, 40, 30, 20, 10, 0],
                        backgroundColor: 'cadetblue',
                        label: this.translate('results'),
                    }
                ]
            }

            this.dataFive = {
                labels: this.monthList,
                datasets: [
                    {
                        label: 'Checklists Aprovado',
                        data: this.randomNumbers(this.monthList.length)
                    },
                    {
                        label: 'Checklists Reprovados',
                        data: this.randomNumbersTwo(this.monthList.length)
                    },
                ]
            }

            this.dataSix = {
                labels: this.monthList,
                datasets: [
                    {
                        label: '% Aprovado',
                        data: this.randomPorcent(this.monthList.length)
                    },
                    {
                        label: '% Reprovados',
                        data: this.randomPorcentTwo(this.monthList.length)
                    },
                ]
            }  
        })
    }

    // validation functions to alignment the data on screen
    showValue = (number: number) => number != 0 ? true : false;
    bothValuesIsZero = (v1, v2) => v1 == 0 && v2 == 0 ? true : false;
    sizeValidationDouble = (v1, v2) => v1 != 0 && v2 != 0 ? 'ui-g-12' : 'ui-g-6';
    sizeValidation = (v) => v == 0 ? 'ui-g-12 ui-sm-12 ui-md-12' : 'ui-g-6 ui-sm-12 ui-md-6';

    // random numbers to example
    randomPorcent = (count: number) => new Array(count).fill(0).map(() => Math.floor(Math.random() * 100) + 1);
    randomPorcentTwo = (count: number) => new Array(count).fill(0).map(() => Math.floor(Math.random() * 100) + 1 / 4);
    randomNumbers = (count: number) => new Array(count).fill(0).map(() => Math.floor(Math.random() * 1000) + 1);
    randomNumbersTwo = (count: number) => new Array(count).fill(0).map(() => Math.floor(Math.random() * 1000) + 1 / 4);

    translate = (key: string) => this.translateService.instant(key || "invalid");
	tCap = (key) => this.translate(key).charAt(0).toUpperCase() + this.translate(key).slice(1);
	tUpper = (key) => this.translate(key).toString().toUpperCase();

}

/*
    setDataTwoOld(response: any) {
        let { total, values } = response;

        this.dataTwo.datasets[0].data = values.map((field) => field.total);
        // this.dataTwo.labels = values.map((field) => field.status); // English values
        this.totalTwo = total;
    }
*/



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/dashboard/dashboard.component.ts